import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { AuthLayout } from './AuthLayout';
import styles from './AuthLayout.module.css';

import { Alert } from '@/components/Alert';
import { Button } from '@/components/Button';
import { Field } from '@/components/Field';
import { authApi } from '@/lib/authApi';

/**
 * Pedido de redefinição de senha (RF-01.05).
 *
 * A confirmação é a mesma exista a conta ou não — e a tela nem trata falha de
 * forma diferente, porque o servidor responde 202 em qualquer caso e
 * distinguir aqui recriaria o oráculo que ele evita (docs/11 §2.4).
 */
export function ForgotPasswordPage(): JSX.Element {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDone, setIsDone] = useState(false);

  async function handleSubmit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      await authApi.forgotPassword(email);
    } finally {
      setIsDone(true);
      setIsSubmitting(false);
    }
  }

  if (isDone) {
    return (
      <AuthLayout
        footer={<Link to="/entrar">Voltar para o acesso</Link>}
        title="Verifique seu e-mail"
      >
        <Alert title="Pedido recebido" tone="success">
          Se houver uma conta com <strong>{email}</strong>, enviamos um link de redefinição. Ele
          vale por 1 hora.
        </Alert>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      footer={<Link to="/entrar">Voltar para o acesso</Link>}
      subtitle="Informe seu e-mail e enviaremos um link para criar uma senha nova."
      title="Esqueci minha senha"
    >
      <form className={styles.form} noValidate onSubmit={(event) => void handleSubmit(event)}>
        <Field
          autoComplete="email"
          inputMode="email"
          label="E-mail"
          name="email"
          onChange={(event) => setEmail(event.target.value)}
          required
          type="email"
          value={email}
        />

        <Button loading={isSubmitting} type="submit">
          Enviar link
        </Button>
      </form>
    </AuthLayout>
  );
}
